import './careers.css';
import React from 'react';
import softwareDesktop from '../../images/careersPage/careers-Software-Desktop.png';
import softtwareMobile from '../../images/careersPage/careers-Software-Mobile.png';
import SoftwareText from './SoftwareText';

const Software = () => {
  // const imageUrl = window.innerWidth >= 768 ? softwareDesktop : softtwareMobile;
  return (
    <div className="greyframe">
      <div className="software-container container">
        <div className="innerbox">
          <div className="header">SOFTWARE</div>
          <SoftwareText />
        </div>
        <div className="imagedivSoftware">
          <img className="desktopSoftwareImage" src={softwareDesktop} />
        </div>
        <img className="mobileSoftwareImage" src={softtwareMobile} />
      </div>
    </div>
  );
};

export default Software;



// WEBPACK FOOTER //
// ./src/components/Careers/Software.js